import { FC, useEffect, useRef } from "react"
import WasmCanvas from "@/wasm3d/WasmCanvas"
import {
  attachmentModule,
  initSettingView,
  viewControlInTreatment,
  wasmModule,
} from "@/gluelayer"
import { singleData } from "@/UDTreat/UDesign/Attachments/columns"
import { useAppSelector } from "@/core/app/hooks"
import { RootState } from "@/core/app/store"

export const Attachment3D: FC<{ initCallBack?: () => void }> = ({
  initCallBack,
}) => {
  const canvasRef = useRef<HTMLCanvasElement | null>(null)
  const { drawAuxullarties } = viewControlInTreatment
  const { attachInit } = useAppSelector((state: RootState) => state.userService)

  useEffect(() => {
    const initCanvas = () => {
      const canvas = document.getElementById("canvas") as HTMLCanvasElement
      if (canvas && !canvasRef.current) {
        canvasRef.current = canvas
        initSettingView(canvas).then(() => {
          drawAuxullartiesGrid()
          initCallBack && initCallBack()

          // if (!attachInit) {
          //   setTimeout(() => {
          //   }, 200) // 200ms for drawAuxullartiesGrid to finish
          // } else {
          //   initCallBack && initCallBack()
          // }
        })
      }
    }

    initCanvas()

    const checkInterval = setInterval(() => {
      const canvas = document.getElementById("canvas") as HTMLCanvasElement
      if (canvas && !canvasRef.current) {
        canvasRef.current = canvas
        initSettingView(canvas).then(() => {
          drawAuxullartiesGrid()
          initCallBack && initCallBack()

          // if (!attachInit) {
          //   setTimeout(() => {
          //     initCallBack && initCallBack()
          //   }, 200) // 200ms for drawAuxullartiesGrid to finish
          // } else {
          //   initCallBack && initCallBack()
          // }
        })
        clearInterval(checkInterval)
      }
    }, 100)

    return () => {
      clearInterval(checkInterval)
    }
  }, [])

  const drawAuxullartiesGrid = () => {
    const auxTmp = [{ type: "Normal", elements: [] }] as any
    singleData.subData.map((item) => {
      item.data.map((i) => {
        const ele = document.getElementById(`${i.name}${i.key}`)
        auxTmp[0].elements.push([i.id, ele])
      })
    })

    const canvasRoot = document.getElementById("scrollWrap")
    if (!canvasRoot || attachInit) return
    drawAuxullarties(canvasRoot, auxTmp)
  }

  return (
    <div
      style={{
        width: "100%",
        height: "100%",
        position: "relative",
        // background: "linear-gradient(to top, #000000 0%, #717272 100%)",
      }}
    >
      <WasmCanvas />
    </div>
  )
}
